module.exports = __webpack_public_path__ + "static/media/ico-info-white.7a6dec1c.svg";